import $ from 'jquery';

$('.js-highlight').each(function (index, element) {
  const $element = $(element);
  const regex = /\((.+)\)/gi;
  const regexHtml = $element
    .html()
    .replace(regex, '(<span class="menu-item__highlight">$1</span>)');
  $element.html(regexHtml);
});
